"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rupees = function (value, insertRupeeSymbol, insertSpaceAfterMinus, retainDecimalPlaces, removeSpaceAfterRupee) {
    if (value === void 0) { value = 0; }
    if (insertRupeeSymbol === void 0) { insertRupeeSymbol = false; }
    if (insertSpaceAfterMinus === void 0) { insertSpaceAfterMinus = false; }
    if (retainDecimalPlaces === void 0) { retainDecimalPlaces = false; }
    if (removeSpaceAfterRupee === void 0) { removeSpaceAfterRupee = false; }
    if (!value) {
        value = 0;
    }
    if (!isNaN(value)) {
        value = Number(value);
    }
    value = value.toString();
    var number = parseFloat(value
        .replace(/[^\d\-.]/g, '')
        .replace(/(\.\d\d)(\d*)$/g, '$1'));
    var formattedNumber = Math.abs(number)
        .toFixed(2)
        .replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
        .replace(/(\.00)$/, retainDecimalPlaces ? '$1' : '');
    return [
        number < 0 ? '-' : '',
        number < 0 && insertSpaceAfterMinus ? ' ' : '',
        insertRupeeSymbol ? '₹' : '',
        insertRupeeSymbol && !removeSpaceAfterRupee ? ' ' : '',
        formattedNumber,
    ].join('');
};
